import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateCustomerTransferStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateCustomerTransferStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateCustomerTransferStatusAttempt', handleUpdateCustomerTransferStatus, api);
}

function* handleUpdateCustomerTransferStatus(api: ApprovalGateway, data: PayloadAction<TUpdateCustomerTransferStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateCustomerTransferStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateCustomerTransferStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === TransactionStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveCustomerTransferSuccess
            : status === TransactionStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectCustomerTransferSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateCustomerTransferStatusModalIsOpen(false));

        toast.success(successMessage);

        yield put(combinedActions.approvalGetPendingCustomerTransferListingAttempt());
        yield put(combinedActions.approvalUpdateCustomerTransferStatusSuccess());
    }
}
